import React, { useState } from 'react';
import './Return.css';
const Return = () => {
  const [orderNumber, setOrderNumber] = useState('');
  const [reason, setReason] = useState('');

  const handleReturn = (e) => {
    e.preventDefault();
    // Handle return logic here
    console.log("Returning order:", orderNumber, "Reason:", reason);
  };

  return (
    <div className="form-container">
      <h2>Return an Order</h2>
      <form onSubmit={handleReturn}>
        <div className="form-group">
          <label htmlFor="order-number">Order Number</label>
          <input
            type="text"
            id="order-number"
            value={orderNumber}
            onChange={(e) => setOrderNumber(e.target.value)}
            required
            placeholder="Enter your order number"
          />
        </div>
        <div className="form-group">
          <label htmlFor="reason">Reason for Return</label>
          <textarea
            id="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            required
            placeholder="Describe the reason for return"
          ></textarea>
        </div>
        <button type="submit">Proceed with Return</button>
      </form>
    </div>
  );
};

export default Return;
